
import { TranslationSet } from '../../types';

export const galleryBasic: TranslationSet = {
  'gallery.title': {
    en: 'Photo Gallery',
    ja: '写真ギャラリー',
    es: 'Galería de fotos',
    zh: '照片库',
    fa: 'گالری عکس'
  },
  'gallery.description': {
    en: 'Store and organize your baby\'s precious moments',
    ja: '赤ちゃんの大切な瞬間を保存して整理する',
    es: 'Guarda y organiza los momentos preciosos de tu bebé',
    zh: '存储和整理您宝宝的珍贵时刻',
    fa: 'ذخیره و سازماندهی لحظات ارزشمند کودک شما'
  },
  'gallery.empty': {
    en: 'No photos yet',
    ja: 'まだ写真がありません',
    es: 'Aún no hay fotos',
    zh: '暂无照片',
    fa: 'هنوز عکسی وجود ندارد'
  },
  'gallery.subtitle': {
    en: 'Capture and preserve your baby\'s growth journey',
    ja: '赤ちゃんの成長の旅を撮影して保存',
    es: 'Captura y preserva el viaje de crecimiento de tu bebé',
    zh: '捕捉并保存宝宝的成长历程',
    fa: 'ثبت و حفظ مسیر رشد کودک شما'
  },
  'gallery.recentPhotos': {
    en: 'Recent Photos',
    ja: '最近の写真',
    es: 'Fotos recientes',
    zh: '最近的照片',
    fa: 'عکس‌های اخیر'
  },
  'gallery.milestonePhotos': {
    en: 'Milestone Photos',
    ja: 'マイルストーン写真',
    es: 'Fotos de hitos',
    zh: '里程碑照片',
    fa: 'عکس‌های مراحل رشد'
  },
  'gallery.noPhotos': {
    en: 'No photos yet',
    ja: 'まだ写真がありません',
    es: 'Aún no hay fotos',
    zh: '暂无照片',
    fa: 'هنوز عکسی وجود ندارد'
  },
  'gallery.yourBabyPhotosHere': {
    en: 'Your baby\'s photos will appear here',
    ja: '赤ちゃんの写真がここに表示されます',
    es: 'Las fotos de tu bebé aparecerán aquí',
    zh: '您宝宝的照片将显示在这里',
    fa: 'عکس های کودک شما در اینجا نمایش داده خواهد شد'
  },
  'gallery.yourPregnancyPhotosHere': {
    en: 'Your pregnancy journey photos will appear here',
    ja: 'あなたの妊娠の旅の写真がここに表示されます',
    es: 'Las fotos de tu viaje de embarazo aparecerán aquí',
    zh: '您的怀孕之旅照片将显示在这里',
    fa: 'عکس‌های دوران بارداری شما در اینجا نمایش داده خواهد شد'
  },
  'gallery.uploadAfterSignup': {
    en: 'Upload your own photos after signing up',
    ja: 'サインアップ後に自分の写真をアップロード',
    es: 'Sube tus propias fotos después de registrarte',
    zh: '注册后上传您自己的照片',
    fa: 'پس از ثبت نام عکس‌های خود را آپلود کنید'
  },
  'gallery.selectWeekToPreview': {
    en: 'Select a week to see a preview',
    ja: 'プレビューを見るには週を選択してください',
    es: 'Selecciona una semana para ver una vista previa',
    zh: '选择一周以查看预览',
    fa: 'یک هفته را برای مشاهده پیش‌نمایش انتخاب کنید'
  },
  'gallery.signInToViewPhotos': {
    en: 'Sign in to upload and manage your own photos',
    ja: 'サインインして自分の写真をアップロードして管理する',
    es: 'Inicia sesión para subir y administrar tus propias fotos',
    zh: '登录以上传和管理您自己的照片',
    fa: 'برای آپلود و مدیریت عکس‌های خود وارد شوید'
  },
  'gallery.premiumFeature': {
    en: 'Premium Feature',
    ja: 'プレミアム機能',
    es: 'Función Premium',
    zh: '高级功能',
    fa: 'ویژگی پرمیوم'
  },
  'gallery.sortBy': {
    en: 'Sort by',
    ja: '並び替え',
    es: 'Ordenar por',
    zh: '排序方式',
    fa: 'مرتب‌سازی بر اساس'
  },
  'gallery.newest': {
    en: 'Newest',
    ja: '最新',
    es: 'Más reciente',
    zh: '最新',
    fa: 'جدیدترین'
  },
  'gallery.oldest': {
    en: 'Oldest',
    ja: '最古',
    es: 'Más antiguo',
    zh: '最旧',
    fa: 'قدیمی‌ترین'
  },
  'gallery.guestDemo': {
    en: 'Guest Demo',
    ja: 'ゲストデモ',
    es: 'Demo de invitado',
    zh: '访客演示',
    fa: 'نسخه نمایشی مهمان'
  },
  'gallery.sampleDescription': {
    en: 'These are sample images. Sign up to upload your own photos.',
    ja: 'これらはサンプル画像です。サインアップして自分の写真をアップロードしてください。',
    es: 'Estas son imágenes de muestra. Regístrate para subir tus propias fotos.',
    zh: '这些是示例图像。注册以上传您自己的照片。',
    fa: 'این‌ها تصاویر نمونه هستند. برای آپلود عکس‌های خود ثبت‌نام کنید.'
  }
};
